/* ═══════════════════════════════════════════════════════════
 *  OUTFIT — Thème "Blanc Couture"
 *  Fond blanc pur, typographie noire, accents bronze chaud
 * ═══════════════════════════════════════════════════════════ */

export const colors = {
  /* Backgrounds */
  bg: {
    base:    '#FFFFFF',
    surface: '#FAFAF8',
    card:    '#FFFFFF',
    raised:  '#F5F4F0',
    border:  '#E8E4DC',
    subtle:  '#F0EDE6',
  },
  /* Bronze / Taupe accents */
  accent: {
    main:    '#9B7B5A',   /* bronze chaleureux */
    light:   '#C4A882',   /* bronze clair */
    pale:    '#E8D9C8',   /* sable clair */
    ghost:   '#F5EFE8',   /* fond accent */
    dark:    '#6B5440',   /* bronze foncé */
  },
  /* Texte */
  text: {
    primary:   '#1A1814',   /* noir chaud */
    secondary: '#4A453D',   /* gris brun */
    muted:     '#7A7268',   /* gris moyen */
    faint:     '#A89E94',   /* gris clair */
    ghost:     '#C8C0B4',   /* très clair */
  },
  /* Statuts */
  status: {
    success: '#3D7A56',
    warning: '#9B7B5A',
    error:   '#B04040',
    info:    '#3D6A9B',
  },
  /* Partenaires */
  partners: {
    zalando:  '#FF6900',
    asos:     '#000000',
    farfetch: '#1B1B1B',
    amazon:   '#FF9900',
    hm:       '#E50010',
    mango:    '#8C6039',
  },
};

export const typography = {
  logo:    { fontSize: 24, letterSpacing: 8,   fontWeight: '300', color: colors.text.primary },
  h1:      { fontSize: 28, letterSpacing: 0.5, fontWeight: '300', color: colors.text.primary },
  h2:      { fontSize: 20, letterSpacing: 0.3, fontWeight: '400', color: colors.text.primary },
  h3:      { fontSize: 16, letterSpacing: 0.2, fontWeight: '500', color: colors.text.primary },
  label:   { fontSize: 9,  letterSpacing: 3,   fontWeight: '500', color: colors.text.faint, textTransform: 'uppercase' },
  body:    { fontSize: 14, letterSpacing: 0.2, color: colors.text.secondary, lineHeight: 22 },
  caption: { fontSize: 11, letterSpacing: 0.5, color: colors.text.secondary },
  price:   { fontSize: 16, letterSpacing: 0.3, fontWeight: '600', color: colors.text.primary },
  cta:     { fontSize: 11, letterSpacing: 3,   fontWeight: '600', color: '#FFFFFF', textTransform: 'uppercase' },
};

export const spacing = {
  xs: 4, sm: 8, md: 14, lg: 20, xl: 24, xxl: 32,
};

export const radius = {
  xs: 4, sm: 10, md: 14, lg: 20, xl: 28, pill: 100,
};

export const shadow = {
  sm: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.06,
    shadowRadius: 4,
    elevation: 2,
  },
  md: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.08,
    shadowRadius: 10,
    elevation: 4,
  },
  lg: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.10,
    shadowRadius: 20,
    elevation: 8,
  },
};
